import type { LanguageCode } from "../shared";

export interface PreviewRow {
  text: Record<LanguageCode, string>;
  pronunciation: string;
}

/** The lesson Day 1 opens with, inlined so the homepage sheet needs no fetch. */
export const PREVIEW_TOPIC = { emoji: "👋", title: "Greetings" } as const;

/**
 * Day 1 of the starter course, word for word, inlined so the homepage sheet
 * renders instantly and promises exactly what the printed sheet delivers.
 */
export const PREVIEW_ROWS: PreviewRow[] = [
  {
    text: { th: "สวัสดี", nl: "Hallo / Tot ziens", en: "Hello / Goodbye" },
    pronunciation: "sà-wàt-dee",
  },
  {
    text: { th: "ขอบคุณ", nl: "Dank je wel", en: "Thank you" },
    pronunciation: "khàwp-khun",
  },
  {
    text: { th: "สบายดีไหม", nl: "Hoe gaat het?", en: "How are you?" },
    pronunciation: "sà-baai-dee mǎi",
  },
  {
    text: { th: "สบายดี", nl: "Het gaat goed", en: "I'm fine" },
    pronunciation: "sà-baai-dee",
  },
  {
    text: {
      th: "ยินดีที่ได้รู้จัก",
      nl: "Aangenaam kennis te maken",
      en: "Nice to meet you",
    },
    pronunciation: "yin-dee thêe dâai rúu-jàk",
  },
  {
    text: {
      th: "ไม่เป็นไร",
      nl: "Graag gedaan / Geeft niet",
      en: "You're welcome / Never mind",
    },
    pronunciation: "mâi bpen rai",
  },
];

export const PREVIEW_SENTENCES: PreviewRow[] = [
  {
    text: {
      th: "สวัสดีครับ ผมชื่อจอห์น",
      nl: "Hallo. Ik heet John.",
      en: "Hello. My name is John.",
    },
    pronunciation: "Sà-wàt-dee khráp. Phǒm chêu John.",
  },
  {
    text: {
      th: "ขอบคุณมากครับ",
      nl: "Heel erg bedankt.",
      en: "Thank you very much.",
    },
    pronunciation: "Khàwp-khun mâak khráp.",
  },
];
